const sw = {
  translation: {
    salutation: "hej där",
    introduction: "jag är",
    introudction_job_title: "och jag är en",
    developer: "utvecklare",
    download: "ladda ner",
    cv: "CV",
    select: "välj",
    experiance_years: "{{years}} år",
    of_experiance: "av erfarenhet",
    my_portofolio: "mitt portfolio",
    portofolio: "portfolio",
    testimonials: "referenser",
    all: "alla",
    about: "om",
    skill_level_question: "vilken är min färdighetsnivå",
    see_more: "se mer",
    achievements: "prestationer",
    personal_info: "personlig information",
    experience: "erfarenhet",
    education: "utbildning",
    skills_and_technology: "färdigheter och teknik",
    hide: "göm",
    get_in_touch: "kom i kontakt",
    send_message: "skicka meddelande",
    message: "meddelande",
    subject: "ämne",
    your_name: "ditt namn",
    email_address: "e-postadress",
    talk_statment: "låt oss prata om allt",
    like_form_question: "gillar inte formulär",
    send_me: "skicka mig ett",
    email: "e-post",
    language: "språk",
    home_page: "hem",
    me: "jag",
    my_experience: "min erfarenhet",
    coming_soon: "kommer snart",
    this_page_is_under_construction: "den här sidan är under konstruktion",
    is_required_field: "{{field}} är obligatoriskt fält",
  },
};

export default sw;
